import React from 'react';
import { UserProfileProps, useUserProfile } from '../../../providers/user-provider';
import { INotification,INotificationdata } from '../../../types';
import JsonRTE from '../../basic/jsonRTE';

export default function NotificationBanner({ notificationProps }: INotification) {
  const [signnedIn,setSignnedIn]=React.useState(false)
  const { userProfile } = useUserProfile();
  if(!notificationProps || notificationProps.length==0){
    return<></>;
  }

  const GlobalNotification:INotificationdata = notificationProps[0];
  const SignedInNotification:INotificationdata =notificationProps[1];
  const LogoutNotification:INotificationdata=notificationProps[2];

  if(GlobalNotification.isenabled){
    return NotificationContent(GlobalNotification.json_rte)
  }
  if(userProfile && !signnedIn){
    setSignnedIn(true)
  }
  
  function NotificationContent(data:any){
    return (
    <div
        id="notification"
        className="flex items-center justify-center text-sm text-center bg-secondary-500 px-lg py-xs border-1 border-current"
        aria-label='Notifications'
        data-testid='notification'
    >
        <span className="text-white">
          <JsonRTE json={data}/>
        </span>
    </div> 
    )
  } 
  
  return(
      <>  
        {userProfile && SignedInNotification.isenabled && NotificationContent(SignedInNotification.json_rte) }
        {signnedIn && !userProfile && LogoutNotification.isenabled && NotificationContent(LogoutNotification.json_rte) }
      </>
  );
}